import { CommonElementId } from "../Common/constants";
const EscapeKey = "Escape";
const EnterKey = "Enter";
const Keydown = "keydown";
export function focusMessageBox() {
    const messageBox = document.getElementById(CommonElementId.MessageInputBox);
    if (messageBox) {
        messageBox.focus();
    }
}
export function focusChatIcon() {
    const launchButton = document.getElementById(CommonElementId.AlmeLaunchButton);
    if (launchButton) {
        launchButton.focus();
    }
}
export function onEnterKeyPress(evt, onKeyPress) {
    if (evt.key === EnterKey) {
        onKeyPress();
    }
}
export function onKeyEscape(element, onEscapeFn) {
    element.addEventListener(Keydown, (e) => {
        const eventKey = e.key;
        if (eventKey === EscapeKey) {
            e.preventDefault();
            onEscapeFn();
        }
    });
}
export const doScroll = (ref) => {
    if (ref && ref.current && ref.current.scrollIntoView) {
        ref.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }
};
export function observeMutations(elementSelector, callback, options) {
    const element = typeof elementSelector === 'string' ? document.querySelector(elementSelector) : elementSelector;
    if (!element) {
        return null;
    }
    const observer = new MutationObserver(callback);
    observer.observe(element, options);
    return observer;
}
export function fieldValidation(selectedAccount, isRequired) {
    let error = "";
    if (selectedAccount.length === 0 && isRequired) {
        error = "Please select at least one account to change the address.";
    }
    return error;
}
